"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M3 13.8758V17H6.12422C4.81297 16.2724 3.72762 15.187 3 13.8758Z",
    fill: "#727B7F"
  }), react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C5.582 2 2 5.582 2 10C2 11.4061 2.36284 12.7276 3 13.8758C3.72762 15.187 4.81297 16.2724 6.12422 17C7.27244 17.6372 8.59388 18 10 18C14.418 18 18 14.418 18 10C18 5.582 14.418 2 10 2ZM11.621 13.869C12.108 14.012 13.137 13.758 13.62 13.21C14.0536 12.7172 14.0085 12.2074 13.9875 11.9701C13.9851 11.943 13.983 11.9195 13.982 11.9C13.973 11.71 13.81 11.681 13.81 11.681C13.81 11.681 12.476 11.002 12.202 10.87C11.928 10.738 11.788 10.953 11.788 10.953C11.788 10.953 11.384 11.49 11.254 11.666C11.2435 11.6803 11.2333 11.6944 11.2233 11.7082C11.1101 11.8655 11.0215 11.9885 10.71 11.881C10.37 11.764 9.689 11.379 9.134 10.856C8.578 10.332 8.153 9.639 8.032 9.429C7.911 9.219 8.051 9.087 8.051 9.087C8.051 9.087 8.403 8.661 8.571 8.433C8.73694 8.20815 8.63872 7.95823 8.59724 7.85269L8.595 7.847C8.555 7.743 8.014 6.408 7.934 6.22C7.855 6.031 7.683 6 7.683 6H7.042C6.928 6 6.707 6.147 6.707 6.147C6.048 6.59 5.936 7.625 5.917 7.849C5.897 8.072 5.879 8.546 6.226 9.344C6.574 10.143 7.425 11.226 8.474 12.255C9.39761 13.161 11.0206 13.6939 11.5651 13.8526L11.621 13.869Z",
    fill: "#727B7F"
  }));
};